import { render, staticRenderFns } from "./hospitalDetail.vue?vue&type=template&id=ac1566f4"
import script from "./hospitalDetail.vue?vue&type=script&lang=js"
export * from "./hospitalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports